export default __webpack_public_path__ + "static/media/Roselyne_Wanjiru_AHV_In_Moms_We_Trust.ce58874d.jpg";